var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.875 4.3125H22.4375V10.3125H25.875V4.3125Z",
    fill: "#DE6137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 1.25H21.125V4.50002H27.1875V1.25Z",
    fill: "#FF8258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 16.1875V30H27.125V16.1875C22.3125 11.375 19.625 8.68752 14.875 3.9375C10.125 8.74998 7.43748 11.4375 2.625 16.1875Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 16.1875C22.375 11.375 19.6875 8.68752 14.9375 3.9375C12.5 6.31248 10.625 8.18748 8.74998 10.0625C6.87498 11.9375 4.99998 13.8125 2.625 16.1875V18.9999C7.43748 14.1875 10.125 11.5 14.875 6.74994C19.6875 11.5624 22.375 14.2499 27.125 18.9999V19.375V16.1875H27.1875V16.1875Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 30H5.3125V22.75C5.3125 20.6875 7 19.0625 8.99998 19.0625C11.0625 19.0625 12.6875 20.75 12.6875 22.75V30Z",
    fill: "#074B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.0625H14.875V27.5H24.5V19.0625Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 20.0625H15.875V26.5H19.1875V20.0625Z",
    fill: "#9DC1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.0625H20.1875V26.5H23.5V20.0625Z",
    fill: "#9DC1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4375 13.625L16.375 0.5625C15.625 -0.1875 14.3125 -0.1875 13.5625 0.5625L0.5625 13.625C-0.1875 14.375 -0.1875 15.6875 0.5625 16.4375C1.3125 17.1875 2.625 17.1875 3.375 16.4375L15 4.81248L26.625 16.4375C27.375 17.1875 28.6875 17.1875 29.4375 16.4375C30.1875 15.625 30.1875 14.375 29.4375 13.625Z",
    fill: "#FF8258"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.487dcf85bf5aeb8b6fac3822589c5ab3.svg";
export { ForwardRef as ReactComponent };